import { z } from "zod";

export const UsageSchema = z.object({
	id: z.number(),
	filtered: z.number(),
	identified: z.number(),
	month: z.number(),
	year: z.number(),
});

export const AiUsageSchema = z.object({
	id: z.number().optional(),
	inputTokens: z.number(),
	outputTokens: z.number(),
	month: z.number(),
	year: z.number(),
});

export const UsageResponseSchema = z.object({
	usage: z.array(UsageSchema),
	aiUsage: z.array(AiUsageSchema),
	limits: z.object({
		identified: z.number(),
		filtered: z.number(),
		inputTokens: z.number(),
		outputTokens: z.number(),
	}),
});

export const PendingPlanChangeSchema = z.object({
	credits: z.coerce.number(),
	productName: z.string(),
	interval: z.enum(["month", "quarter", "half_year", "year"]),
	effectiveAt: z.string(),
});

export const CreditsResponseSchema = z.object({
	credits: z.number(),
	usedCredits: z.number(),
	cycleCredits: z.number(),
	limit: z.number(),
	nextCycle: z.string(),
	rolloverCredits: z.number(),
	perMonthOrYear: z.string(),
	stripeSubscription: z.any(),
	stripeProduct: z.any(),
	stripePrice: z.any(),
	stripeSubscriptionSchedulers: z.array(z.any()),
	upcomingInvoice: z.any(),
	pendingPlanChange: PendingPlanChangeSchema.nullable().optional(),
	/**
	 * The cancellation as recorded on our own subscription row (PREC-3922). `stripeSubscription`
	 * above is served from a per-process cache on the API, so it can be stale right after a
	 * cancellation; these two are written by our own cancel path and are correct everywhere.
	 */
	cancellation: z
		.object({
			endedAt: z.string().nullable(),
			canceledAt: z.string().nullable(),
		})
		.nullable()
		.optional(),
});

export type Usage = z.infer<typeof UsageSchema>;
export type AiUsage = z.infer<typeof AiUsageSchema>;
export type PendingPlanChange = z.infer<typeof PendingPlanChangeSchema>;
export type CreditsResponse = z.infer<typeof CreditsResponseSchema>;

export type UsageResponse = z.infer<typeof UsageResponseSchema>;
